import React, { Component } from "react";
import TableRow from "./TableRow";
import TableRowEdicion from "./TableRowEdicion";

class TableBody extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tarjetaCreditoId: 0,
            filaClickeadaEnModoEdicion: false
        }

        /*Bindings*/
        this.mostrarFilaEnModoEdicion = this.mostrarFilaEnModoEdicion.bind(this);
    }
    /**
     * Establece la fila en modo edicion
     * @param {any} tarjetaCreditoId Parametro int, representa el id de la tarjeta de credito
     * @param {any} filaEnModoEdicion Parametro booleano, indica si es la misma fila que se esta editando
     */
    mostrarFilaEnModoEdicion(tarjetaCreditoId, filaEnModoEdicion) {
        /*Si filaEnModoEdicion es true, quiere decir que se hizo click en la misma fila para ocultarla*/
        if (this.props.data.seEstaEditando) {
            this.setState({ seIntentaEditar: true });
        } else {
            this.setState({
                tarjetaCreditoId: tarjetaCreditoId,
                filaClickeadaEnModoEdicion: filaEnModoEdicion
            }, this.props.funciones.cancelar());
        }
    }
    /**
     * Devuelve un objeto con el contenido de las novedades de bloqueo, baja y recuperacion, si existe o no y validaciones que refieren al estado de la tarjeta
     * @param {any} props
     * @param {any} tarjeta
     */
    obtenerNovedadesTarjeta(props, tarjeta) {
        const codigoNovedadBaja = "BAJA_TARJ";
        //const codigoNovedadBloqueo = "BLOQU_TARJ";
        const codigoNovedadRecuperada = "RECUP_TARJ";

        const { novedadesTarjetaDatos, novedadesTarjetaDatosCanceladas, motivosBaja, motivosBloqueo } = props.data;

        let novedadBaja = undefined;
        //let novedadBloqueda = undefined;
        let novedadRecuperada = undefined;
        let novedadCancelada = undefined;
        let motivoDescripcion = "";
        let existeNovedad = false;

        /*realizo varios tipos de validaciones ya que hubo casos en los que true realmente no vino como booleano*/
        const validacionBaja = (tarjeta.TieneBaja == "true" || tarjeta.TieneBaja == "1" || tarjeta.TieneBaja == true);
        const validacionBloqueo = (tarjeta.EstaBloqueada == "true" || tarjeta.EstaBloqueada == "1" || tarjeta.EstaBloqueada == true);
        const validacionInhabilitada = (tarjeta.TarjetaCreditoEstadoId == 7);

        /*la validacion de baja predomina sobre todo*/
        if (validacionBaja) {
            const motivo = motivosBaja.find((m) => m.Id == tarjeta.TarjetaBajaMotivoId);
            if (motivo) {
                motivoDescripcion = `Era baja: ${motivo.Descripcion}`
            } else {
                motivoDescripcion = "Era baja"
            }
        }
        /*sigue la de bloqueo*/
        if (validacionBloqueo) {
            const motivo = motivosBloqueo.find((m) => m.Id == tarjeta.TarjetaBloqueoMotivoId);
            if (motivo) {
                motivoDescripcion = `Era bloqueada: ${motivo.Descripcion}`
            } else {
                motivoDescripcion = "Era bloqueada"
            }
        }
        /*la tarjeta no puede estar bloqueda y dada de baja al mismo tiempo*/

        /*si la tarjeta no esta dada de baja o bloqueada, es decir aprobada por la administradora, busco si hay novedades*/
        if (((novedadesTarjetaDatos && novedadesTarjetaDatos.length > 0)
            || novedadesTarjetaDatosCanceladas && novedadesTarjetaDatosCanceladas.length > 0)
            && (validacionBaja == false)) {
            /*busco si tiene al menos una novedad la tarjeta en estado Completada*/
            existeNovedad = novedadesTarjetaDatos.some((ntd) => ntd.CuentaTarjetaId == tarjeta.CuentaTarjetaId
                && ntd.TarjetaCreditoId == tarjeta.TarjetaCreditoId
                && ntd.NovedadEstadoId == 1);
            /*verifico si es de baja*/
            novedadBaja = novedadesTarjetaDatos.find((ntd) => ntd.NovedadCampoCodigo == codigoNovedadBaja
                && ntd.CuentaTarjetaId == tarjeta.CuentaTarjetaId
                && ntd.TarjetaCreditoId == tarjeta.TarjetaCreditoId);
            /*verifico si es bloqueada v0 deprecado*/
            /*no hay mas novedades de bloqueo v1*/
            //novedadBloqueda = novedadesTarjetaDatos.find((ntd) => ntd.NovedadCampoCodigo == codigoNovedadBloqueo
            //    && ntd.CuentaTarjetaId == tarjeta.CuentaTarjetaId
            //    && ntd.TarjetaCreditoId == tarjeta.TarjetaCreditoId);
            /*verifico si es de recuperacion*/
            novedadRecuperada = novedadesTarjetaDatos.find((ntd) => ntd.NovedadCampoCodigo == codigoNovedadRecuperada
                && ntd.CuentaTarjetaId == tarjeta.CuentaTarjetaId
                && ntd.TarjetaCreditoId == tarjeta.TarjetaCreditoId);

            /*si la novedad de baja existe, busco el motivo relacionado y valido que exista, ver que hacer cuando los valores no coinciden*/
            if (novedadBaja) {
                const motivo = motivosBaja.find((m) => m.Id == novedadBaja.ValorNovedad);
                if (motivo) {
                    motivoDescripcion = motivo.Descripcion;
                }
            }
            /*si la novedad de bloqueo existe, busco el motivo relacionado y valido que exista, ver que hacer cuando los valores no coinciden DEPRECADO v0*/
            //if (novedadBloqueda) {
            //    const motivo = motivosBloqueo.find((m) => m.Id == novedadBloqueda.ValorNovedad);
            //    if (motivo) {
            //        motivoDescripcion = motivo.Descripcion;
            //    }
            //}
            /*si la novedad de recuperacion existe, busco el motivo relacionado y valido que exista, ver que hacer cuando los valores no coinciden*/
            if (novedadRecuperada) {
                const motivo = motivosBloqueo.find((m) => m.Id == novedadRecuperada.ValorNovedad);
                if (motivo) {
                    motivoDescripcion = motivo.Descripcion;
                }
            }
            /*busco alguna novedad cancelada tanto la baja como para el bloqueo, este find es usado para no volver a crear una
            nueva novedad sino para actualizar el estado anterior DEPRECADO v0*/
            //novedadCancelada = novedadesTarjetaDatosCanceladas.find((ntdc) => (ntdc.NovedadCampoCodigo == codigoNovedadBloqueo
            //    || ntdc.NovedadCampoCodigo == codigoNovedadBaja)
            //    && ntdc.CuentaTarjetaId == tarjeta.CuentaTarjetaId
            //    && ntdc.TarjetaCreditoId == tarjeta.TarjetaCreditoId);
            /*busco alguna novedad cancelada de la baja, este find es usado para no volver a crear una nueva novedad sino para actualizar el estado anterior v1*/
            novedadCancelada = novedadesTarjetaDatosCanceladas.find((ntdc) => ntdc.NovedadCampoCodigo == codigoNovedadBaja
                && ntdc.CuentaTarjetaId == tarjeta.CuentaTarjetaId
                && ntdc.TarjetaCreditoId == tarjeta.TarjetaCreditoId);
        }

        /*deprecado v0*/
        //return {
        //    existeNovedad,
        //    novedadBaja,
        //    novedadBloqueda,
        //    novedadRecuperada,
        //    novedadCancelada,
        //    motivoDescripcion,
        //    validacionBaja,
        //    validacionBloqueo
        //}

        return {
            existeNovedad,
            novedadBaja,
            novedadRecuperada,
            novedadCancelada,
            motivoDescripcion,
            validacionBaja,
            validacionBloqueo: validacionInhabilitada
        }
    }
    /**
     * 
     * @param {any} nextProps
     */
    componentWillReceiveProps(nextProps) {
        this.state.cargando = false;
        this.state.seIntentaEditar = false;
    }
    /**
     * 
     */
    render() {
        let filasNodos = [];
        const { props, state, mostrarFilaEnModoEdicion, obtenerNovedadesTarjeta } = this;
        const { data, funciones, tarjetas } = props;

        const tableRowEdicionFunciones = {
            actualizarNovedadEstado: funciones.actualizarNovedadEstado,
            cancelar: funciones.cancelar,
            changeCheck: funciones.changeCheck,
            changeInput: funciones.changeInput,
            estadoEdicion: funciones.estadoEdicion,
            guardarNovedad: funciones.guardarNovedad,
            mostrarModal: funciones.mostrarModal,
            selectCombo: funciones.selectCombo,
            getDiasVigencia: funciones.getDiasVigencia
        }

        /*Atributos de novedades y motivos*/
        const { novedadesTarjetaDatosCanceladas, novedadesTarjetaDatos, motivosBloqueo, motivosBaja } = data;

        tarjetas.forEach((tar) => {
            /*me indica si tengo o no que renderizar el componente con los datos de la tarjeta, para mas informacion de como se
            evalua ver condicion mas abajo*/
            let puedeEjecutar = false;
            const resultado = obtenerNovedadesTarjeta(props, tar);

            let modoEdicion = (tar.TarjetaCreditoId == state.tarjetaCreditoId);

            if (modoEdicion == true && state.filaClickeadaEnModoEdicion == true) {
                modoEdicion = false;
            }

            /*esta caso unicamente ocurriria si la administradora aprobo una novedad de bloqueo y el usuario la intento recuperar*/
            if (resultado.novedadBaja == undefined && resultado.novedadRecuperada) {
                puedeEjecutar = true;
            } else {
                /*DEPRECADO v0*/
                //puedeEjecutar = (resultado.novedadBaja == undefined
                //    && resultado.novedadBloqueda == undefined
                //    && resultado.validacionBaja == false
                //    && resultado.validacionBloqueo == false);
                /*v1*/
                puedeEjecutar = (resultado.novedadBaja == undefined
                    && resultado.validacionBaja == false
                    && resultado.validacionBloqueo == false);
            }

            filasNodos.push(
                <TableRow
                    data={data}
                    filaEnModoEdicion={modoEdicion}
                    novedad={resultado}
                    puedeEjecutar={puedeEjecutar}
                    tarjeta={tar}

                    actualizarNovedadEstado={funciones.actualizarNovedadEstado}
                    guardarNovedad={funciones.guardarNovedad}
                    guardarNovedadBloqueo={funciones.guardarNovedadBloqueo}
                    mostrarFilaEnModoEdicion={mostrarFilaEnModoEdicion}
                    selectCombo={funciones.selectCombo} />
            );

            /*si se cumple lo evaluado previamente, renderizo*/
            if (puedeEjecutar) {
                filasNodos.push(
                    <TableRowEdicion
                        data={data}
                        tarjeta={tar}
                        tieneAlgunaNovedad={resultado.existeNovedad}
                        filaEnModoEdicion={modoEdicion}
                        seIntentaEditar={state.seIntentaEditar}
                        funciones={tableRowEdicionFunciones}
                        tarjetas={tarjetas}
                    />
                );
            }
        });

        return <tbody className="tarjetas">
            {this.state.cargando && <div className="loading"> Loading &#8230;</div>}
            {filasNodos}
        </tbody>
    }
}

export default TableBody;